export const NaviItemStyle = {
    display: "inline-block",
    marginRight: "24px"
}